export default __webpack_public_path__ + "static/media/thomas.74900982.png";